export const getDelayUntilLoopBoundary = (loopStartedAt: number, now: number, loopDurationMs: number): number => {
  const loopsToFinish = Math.max(1, Math.ceil((now - loopStartedAt) / loopDurationMs));
  return loopStartedAt + loopsToFinish * loopDurationMs - now;
};
